import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import PinyinQuiz from './components/PinyinQuiz';

interface QuizPageProps {
  data: {
    Level: string;
    Unit: string;
  };
}

const QuizPage: React.FC<QuizPageProps> = ({ data }) => {
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const theme = useTheme(); // using theme for responsive design

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box sx={{
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '90vh', // centers everything vertically
      backgroundColor: theme.palette.background.default,
    }}>
      <Typography variant="h4" gutterBottom component="h1" sx={{ fontWeight: 'bold' }}>
        ピンインクイズ
      </Typography>
      <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>
        Current Time: {currentTime}
      </Typography>
      {/* <Typography>Level: {data.Level}, Unit: {data.Unit}</Typography> */}
      <PinyinQuiz />
    </Box>
  );
};

export default QuizPage;
